module.exports = __webpack_public_path__ + "img/hashicon2.fde33d22.svg";